
@if (currentUrl.includes('/news-feed-layout/style-10') || currentUrl.includes('/news-feed-layout/style-11')){
    <app-user-wrap [user]="user" [currentUrl]="currentUrl"></app-user-wrap>
}
<div class="main-icon" [ngClass]="{'d-block d-lg-none' :currentUrl.includes('/news-feed-layout/style-10') || currentUrl.includes('/news-feed-layout/style-11') }">
    <a href="javascript:void(0)">
        <app-feather-icon [class]="'bar-icon'" [icons]="'grid'"></app-feather-icon>
    </a>
</div>

<ul class="sidebar-icon">
    @for (item of menuItemsThird; track $index) {
        <li [class.active]="item.active">
            <a href="javascript:void(0)">
                @if(item.iconType === 'feather'){
                <app-feather-icon [icons]="item.icons" [class]="'bar-icon'"></app-feather-icon>

                <h4>{{item.title}}</h4>
                }                
            </a>
        </li>
    }
    <!-- <li>
        <a href="javascript:void(0)"><h4>Groupes</h4></a>
    </li>
    <li>
        <a href="javascript:void(0)"><h4>Amis</h4></a>
    </li>
    <li>
        <a href="javascript:void(0)"><h4>Videos</h4></a>
    </li>
    <li>
        <a href="javascript:void(0)"><h4>Celebrites</h4></a>
    </li>
    <li>
        <a href="javascript:void(0)"><h4>Suivis</h4></a>
    </li> -->
</ul>

<div class="main-icon" [ngClass]="{'d-block d-lg-none' :currentUrl.includes('/news-feed-layout/style-10') || currentUrl.includes('/news-feed-layout/style-11') }">
    <a href="javascript:void(0)">
        <img src="assets/svg/sidebar-vector/next.svg" class="bar-icon-img" alt="logout">
        <h4>logout</h4>
    </a>
</div>